import React, { Component } from "react";
import Home from "./Puerta";
import Politica from "./Page/Acuerdo/politica";
import Terminos from "./Page/Acuerdo/terminos";
import Eliminar from "./Page/Acuerdo/desecho";
import EliminarPr from "./Page/Acuerdo/desecho/prIndex";
import ErrorInfo from "./Page/ErrorInfo";
import { Router, Route } from "react-router-dom";
import { createBrowserHistory } from "history";
const browserHistory = createBrowserHistory();
class App extends Component {
  render() {
    console.log("----App----");
    return (
      <Router history={browserHistory}>
        <Route exact path="/" component={Home} />
        <Route exact path="/acuerdoDePrivacidad" component={Politica} />
        <Route exact path="/acuerdoDeServicio" component={Terminos} />
        <Route exact path="/errorInfo" component={ErrorInfo} />
        <Route exact path="/dcdesvincular" component={Eliminar} />
        <Route exact path="/dcdesvincularPr" component={EliminarPr} />
      </Router>
    );
  }
}

export default App;
